<template>

  <div class="p-footer w-100 bg-white d-block">
    <div class="p-footer-contet w-100 bottom-fixed d-flex justify-content-center align-items-center">

      <div v-if="item.userProject && !item.userProject.available" class="d-flex align-items-center justify-content-center
      w-100 h-100 bg-grey-light color-base font-15 font-weight-bold">
        您已被拒绝访问
      </div>
      <div class="d-flex w-100 " v-else-if="userState">
        <div class="w-50 pl-3 d-flex flex-column">
          <p class="color-base mb-0 font-weight-bold font-14" v-if="!item.free && item.projectCost>0">
            <span class="font-14 font-weight-normal">¥</span>
            {{item.projectCost}}
          </p>
          <span class="color-99 font-10" v-if="item.projectCost > 0">项目总费用</span>
        </div>
        <div  @click="showPayPage(item)" class="w-40 font-14 down-app-btn">
          <van-button round color="#2474ff" type="info" v-if="item.free || item.projectCost===0">
            报名
          </van-button>
          <van-button round color="#2474ff" type="info" v-if="!item.free && item.projectCost>0">
            购买
          </van-button>
        </div>
      </div>

    </div>
  </div>


</template>

<script>
  import Vue from 'vue';
  import {Button, Dialog} from 'vant';
  import {mapState} from "vuex";

  Vue.use(Dialog);
  Vue.use(Button);

  export default {
    name: "footPrice",
    data() {
      return {
        projectId: '',
        dataModel: {},
        userProject: {}
      }
    },
    props: [
      'item',
      'userState'
    ],
    computed: {
      ...mapState({
        canSignUpTip: state => state.canSignUp
      })
    },
    mounted() {
      this.projectId = this.$route.params['id'];
    },

    methods: {
      showPayPage(item) {
        if(!item.canSignUp) {
          this.$toast(this.canSignUpTip);
          return;
        }
        if (item.free) {
          this.addLearnerProject(item);
        } else {
          this.userProject = {
            startTime: item.startTime,
            endTime: item.endTime,
            cover: item.cover,
            tags: item.tags,
            signedUpCount: item.signedUpCount,
            learnedCount: item.learnedCount,
            entryCost: item.entryCost,
            projectCost: item.projectCost,
            courseList: item.courseList,
            coordinate: item.coordinate,
          },
            ///付费的
            this.$store.dispatch('getLearnerProjectForOrderPreview', {
              id: item.id
            }).then((res) => {
              if (res) {
                /// 支付
                this.addLearnerProject(item);
              }
            },(error) => {
              /// 错误提示
              if (error.response.data.consumerMessage) {
                this.$toast(error.response.data.consumerMessage)
              }
              ///已有订单
              else if (error.response.data.errorType === 'UserProjectAlreadyHasOrderException' &&
                error.response.data.userProject) {
                if (error.response.data.userProject.order.status === 'success') {
                  this.$toast('您已成功报名并支付，请刷新页面进入项目！')
                } else {
                  Dialog.confirm({
                    title: '提示',
                    message: '您已经存在该项目的订单！是否前往详情页继续支付？',
                  }).then(() => {
                    //进支付页面
                    this.$router.push('/order-detail/' + error.response.data.userProject.orderId)
                  })
                }
              }
            })
        }

      },
      addLearnerProject(item) {
        this.$store.dispatch('addLearnerProject', {id: item.id, userProject: this.userProject}).then((res) => {
          if (res) {
            /// 免费项目直接通过
            if (item.free || item.projectCost === 0) {
              Dialog.alert({
                title: '提示',
                message: '您已报名成功！前去选课？',
              }).then(() => {
                //刷新进入选课页面
               this.$router.push('/recommend-project/'+this.projectId);
              })
            } else {
              /// 收费项目 进入支付页面
              this.$router.push('/pay/'+res.order.id)
            }
          }
        },(error)=>{
          /// 错误提示
          if (error.response.data.consumerMessage) {
            this.$toast(error.response.data.consumerMessage)
          }
        })
      },
    },

  }
</script>

<style scoped>

</style>
